// Empty state component

import { Box, Button, Text, VStack } from '@chakra-ui/react';
import { ReactElement } from 'react';

interface EmptyStateProps {
  icon?: ReactElement;
  title: string;
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
}

/**
 * Reusable empty state component
 */
export function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      minH="400px"
      w="full"
      py={12}
    >
      <VStack spacing={4} textAlign="center" maxW="md">
        {icon && <Box color="gray.400">{icon}</Box>}
        <VStack spacing={2}>
          <Text fontSize="xl" fontWeight="semibold" color="gray.700">
            {title}
          </Text>
          {description && (
            <Text fontSize="md" color="gray.600">
              {description}
            </Text>
          )}
        </VStack>
        {action && (
          <Button colorScheme="brand" onClick={action.onClick} mt={4}>
            {action.label}
          </Button>
        )}
      </VStack>
    </Box>
  );
}
